// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"490":"2cd864cf","511":"82e5efea"}[chunkId] + ".chunk.js";
};